export default "__VITE_ASSET__BciKTUp4__"